import { Either } from 'purify-ts';
import { PhoneNumbersRepositoryFailure } from './failure';
import { CompanyPhoneNumber } from './types';

export abstract class IPhoneNumbersRepository {
  public abstract getList(): Promise<Either<PhoneNumbersRepositoryFailure, CompanyPhoneNumber[]>>;
}
